// React
import { useTranslation } from "react-i18next";

// MUI
import {
  AccessTime as TimeIcon,
  CalendarToday as CalendarIcon,
  Business as ClinicIcon,
  LocationOn as LocationIcon,
  Person as PersonIcon,
  Star as StarIcon,
} from "@mui/icons-material";
import { Stack } from "@mui/material";

// Components
import { InfoRow } from "Common/Components";
import { getLocalizedDate, getLocalizedTime } from "Components/Language/Common";
import { getTranslatedReason } from "./getTranslatedReason";

const BookingInfo = ({
  patient,
  client,
  appointment,
  hasChangedTime = false,
  hasChangedDate = false,
}) => {
  const { i18n } = useTranslation();

  if (!patient || !appointment) {
    return null;
  }

  return (
    <Stack spacing={1} alignItems="flex-start">
      <InfoRow
        IconComponent={PersonIcon}
        text={`${patient.firstName} ${patient.lastName}`}
      />
      <InfoRow
        IconComponent={TimeIcon}
        text={getLocalizedTime(appointment.startTime)}
        statusColour={hasChangedTime ? "warning.main" : "primary.main"}
        boldText={hasChangedTime}
      />
      <InfoRow
        IconComponent={CalendarIcon}
        text={getLocalizedDate(appointment.date)}
        statusColour={hasChangedDate ? "warning.main" : "primary.main"}
        boldText={hasChangedDate}
      />
      <InfoRow IconComponent={ClinicIcon} text={appointment.clinicName} />
      <InfoRow IconComponent={LocationIcon} text={appointment.clinicAddress} />
      {client && appointment.type && (
        <InfoRow
          IconComponent={StarIcon}
          text={getTranslatedReason(
            appointment.type,
            client.appointmentReasons,
            i18n.language
          )}
        />
      )}
    </Stack>
  );
};

export default BookingInfo;
